import { render } from "./BaseImgCadastro.vue?vue&type=template&id=1f24f33b"
import script from "./BaseImgCadastro.vue?vue&type=script&lang=js"
export * from "./BaseImgCadastro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__